module.exports = __webpack_public_path__ + "static/img/resource_widget_3.1db15a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/homepage/img/resource_widget_3.png
// module id = vh/e
// module chunks = 11